import React from 'react';
import './progress.css';

type Step = {
  status: 'pending' | 'started' | 'done';
  label: string;
  icon: React.ReactNode;
};

type ProgressProps = {
  steps: Step[];
  currentStep: number;
  onStepClick?: (stepIndex: number) => void;
  /** Optional class on the outer flex row (e.g. theme overrides). */
  wrapClassName?: string;
};

const Progress: React.FC<ProgressProps> = ({ steps, currentStep, onStepClick, wrapClassName }) => {
  if (!steps || !Array.isArray(steps) || steps.length === 0) {
    return <div className="progress-empty text-muted small">—</div>;
  }

  if (typeof currentStep !== 'number' || currentStep < 1) {
    return <div className="progress-empty text-muted small">—</div>;
  }

  return (
    <div className={`progress-container ${wrapClassName ?? ''}`.trim()}>
      {steps.map((step, index) => {
        const isActive = currentStep - 1 === index;
        const isCompleted = currentStep - 1 > index;

        return (
          <React.Fragment key={`${step.status}-${index}`}>
            <div
              className={`progress-step ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
              style={{
                cursor: onStepClick && index > 0 ? 'pointer' : 'default',
              }}
              onClick={() => onStepClick && index > 0 && onStepClick(index + 1)}
            >
              <div className="progress-step-icon">{step.icon}</div>
              <span className="progress-step-label">{step.label}</span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`progress-connector ${isCompleted ? 'progress-connector-done' : ''}`}
                aria-hidden
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Progress;
